const blobToFileUTL = (blob) =>
  new File([blob], blob.name, { type: blob.type });

export default blobToFileUTL;
